const _excluded = ["multiple", "searchable", "container", "companyOptionValue", "roleOptionValue", "userOptionValue", "companyOptionLabel", "roleOptionLabel", "userOptionLabel", "userOptionSubtextRenderer", "optionsOrder", "statusFilters", "optionsFilter", "additionalCompanyDataFields", "additionalUserDataFields", "additionalRoleDataFields", "customUsers", "customRoles", "customCompanies", "postFormatters", "hideDeletedEntitiesInMenu"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { defaultValueTagRenderer, defaultFooterRenderer, defaultMenuItemRenderer } from './helpers/utils';
import { useAssigneePicker } from './hooks';
import MultiAssigneePicker from './layout/MultiAssigneePicker';
import MultiAutocompleteAssigneePicker from './layout/MultiAutocompleteAssigneePicker';
import SingleAssigneePicker from './layout/SingleAssigneePicker';
import SingleAutocompleteAssigneePicker from './layout/SingleAutocompleteAssigneePicker';
const AssigneePicker = _ref => {
  let {
      multiple = true,
      searchable = true,
      container = document.body,
      companyOptionValue,
      roleOptionValue,
      userOptionValue,
      companyOptionLabel,
      roleOptionLabel,
      userOptionLabel,
      userOptionSubtextRenderer,
      optionsOrder,
      statusFilters,
      optionsFilter,
      additionalCompanyDataFields,
      additionalUserDataFields,
      additionalRoleDataFields,
      customUsers,
      customRoles,
      customCompanies,
      postFormatters,
      hideDeletedEntitiesInMenu
    } = _ref,
    baseProps = _objectWithoutProperties(_ref, _excluded);
  const {
    groupedItems: items,
    hiddenMenuItemsIdsSet,
    isLoading
  } = useAssigneePicker({
    companyOptionValue,
    roleOptionValue,
    userOptionValue,
    companyOptionLabel,
    roleOptionLabel,
    userOptionLabel,
    userOptionSubtextRenderer,
    optionsOrder,
    statusFilters,
    optionsFilter,
    additionalCompanyDataFields,
    additionalUserDataFields,
    additionalRoleDataFields,
    customUsers,
    customRoles,
    customCompanies,
    postFormatters,
    hideDeletedEntitiesInMenu
  });
  const props = _objectSpread(_objectSpread({}, baseProps), {}, {
    container,
    isLoading,
    items,
    hiddenMenuItemsIdsSet
  });
  if (multiple) {
    const key = "".concat(items.length > 0 || process.env.NODE_ENV === 'test');
    if (searchable) {
      return /*#__PURE__*/React.createElement(MultiAutocompleteAssigneePicker, _extends({
        key: key
      }, props));
    } else {
      return /*#__PURE__*/React.createElement(MultiAssigneePicker, _extends({
        key: key
      }, props));
    }
  } else {
    if (searchable) {
      return /*#__PURE__*/React.createElement(SingleAutocompleteAssigneePicker, props);
    } else {
      return /*#__PURE__*/React.createElement(SingleAssigneePicker, props);
    }
  }
};
AssigneePicker.defaultValueTagRenderer = defaultValueTagRenderer;
AssigneePicker.defaultMenuItemRenderer = defaultMenuItemRenderer;
AssigneePicker.defaultFooterRenderer = defaultFooterRenderer;
AssigneePicker.propTypes = _objectSpread(_objectSpread({}, useAssigneePicker.propTypes), {}, {
  /**
   * whether to show an icon next to the selected option
   */
  showIcons: PropTypes.bool,
  /**
   * whether to show group count in control token
   */
  showGroupCountInTags: PropTypes.bool,
  /**
   * whether to show avatars in dropdown menu items and possibly control tokens as well
   */
  showAvatars: PropTypes.bool,
  /**
   * whether the filter will reset when an option is selected
   */
  clearFilterOnSelect: PropTypes.bool,
  /**
   * Whether the component is multi selectable
   */
  multiple: PropTypes.bool,
  /**
   * Whether the component is searchable
   */
  searchable: PropTypes.bool,
  /**
   * Dropdown hook props
   */
  dropdownProps: PropTypes.object,
  /**
   * Whether to render the Clear footer
   */
  clearable: PropTypes.bool,
  /**
   *  onChange callback
   */
  onChange: PropTypes.func,
  /**
   * renderer for the Dropdown Control
   */
  renderControl: PropTypes.func,
  /**
   *  renderer for the Dropdown Menu
   */
  renderMenu: PropTypes.func,
  /**
   * renderer for the Virtualized Menu Footer
   */
  renderVirtualizedMenuFooter: PropTypes.func,
  /**
   * renderer for the Menu Item
   */
  renderMenuItem: PropTypes.func
});
export default AssigneePicker;
//# sourceMappingURL=AssigneePicker.js.map